




import { Component, Vue } from 'vue-property-decorator';
import { BButton } from 'bootstrap-vue';
import i18n from "@/i18n";

@Component({
    components: {
        'b-button': BButton
    }
})
export default class LocaleSwitcher extends Vue {
    get locale() {
        return i18n.locale;
    }

    setLocale(locale: string) {
        if (i18n.locale != locale) {
            i18n.locale = locale;
            this.$i18n.locale = locale;
            this.$store.dispatch('setLocale', locale)
                .then(() => {
                    const path = this.$route.path.replace(/^(\/)(?:[a-zA-Z]{2})(\/.*)?$/g, '$1' + locale + '$2');
                    this.$router.push({ path: path });
                });
            this.$root.$emit('LocaleChanged', locale);
        }
    }
}
